import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

import AddressDisplay from "./AddressDisplay"
import RadioInput from "./RadioInput"

import { Address } from '../models'

import { selectedBackground, selectedRadioButtonStyle, radioButtonStyle } from './styles'

let ActiveAddressInAddressSelectorList = (
    {
        address,
        isSelected,
        onSelected,
        onRadioSelected,
        onBeginEdit,
        onDelete,
        selectAddressMessage
    }) => (
        <div>
            <div className='d-flex mt-2'>
                <RadioInput selected={isSelected} onClick={() => onRadioSelected(address.Id)} />
                <AddressDisplay address={address} compact={false} />
            </div>
            <div className="mt-2" style={{ fontWeight: '600' }}>
                <div>
                    <a
                        href=""
                        className='mr-4'
                        onClick={(e) => e.preventDefault() || onSelected(address.Id)}

                    >
                        {selectAddressMessage}
                    </a>
                    <a href="" className="mr-4"
                        onClick={(e) => e.preventDefault() || onBeginEdit(address.Id)}

                    >
                        Edit Address
        </a>
                    <a href="" className="mr-4 vivid-orange"
                        onClick={(e) => e.preventDefault() || onDelete(address.Id)}

                    >
                        Delete
        </a>
                </div>
                
            </div>
        </div>
    )

ActiveAddressInAddressSelectorList.propTypes = {
    address: PropTypes.shape(Address).isRequired,
    isSelected: PropTypes.bool.isRequired,
    onSelected: PropTypes.func.isRequired,
    onRadioSelected: PropTypes.func.isRequired,
    onBeginEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    selectAddressMessage: PropTypes.string.isRequired
}

export default ActiveAddressInAddressSelectorList